export function generateDefaultChartOptions(height: number) {
    return {
        chart: {
            type: "lineChart",
            height,
            margin: {
                top: 20,
                right: 45,
                bottom: 40,
                left: 60
            },
            x(d: any) {
                return d.x;
            },
            y(d: any) {
                return d.y;
            },
            useInteractiveGuideline: true,
            dispatch: {},
            xAxis: {
                axisLabel: "Date",
                tickFormat(d: number) {
                    return d3.time.format("%d/%m/%Y")(new Date(d));
                }
            },
            yAxis: {
                axisLabel: "Profit / Loss"
            }
        }
    };
}
